import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

function CustomToast({ type, title, body, show, onClose }) {
  return (
    <ToastContainer position='bottom-start' className='position-fixed p-3'>
      <Toast
        bg={type}
        onClose={() => onClose()}
        show={show}
        delay={10000}
        autohide
      >
        <Toast.Header className='d-flex justify-content-between'>
          <span>{title}</span>
        </Toast.Header>
        <Toast.Body>{body}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default CustomToast;

export const ToastStatesEnum = Object.freeze({
  success: 'success',
  error: 'danger',
});
